export default "__VITE_ASSET__DfZKpB6q__"